import { useRef, useEffect } from 'react'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

interface SightingsSparklineProps {
  data: string | null
}

export function SightingsSparkline({ data }: SightingsSparklineProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const chartRef = useRef<Chart | null>(null)

  useEffect(() => {
    if (!canvasRef.current || !data) return

    if (chartRef.current) {
      chartRef.current.destroy()
    }

    const values = data.split(/\s+/).map(Number)
    const maxVal = Math.max(...values, 1)

    const labels = values.map((_, i) => {
      const minutesAgo = 90 - i * 5
      if (minutesAgo % 15 === 0) return minutesAgo.toString()
      return ''
    })

    const ctx = canvasRef.current.getContext('2d')!
    chartRef.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          data: values,
          backgroundColor: 'rgba(10, 194, 166, 0.6)',
          borderColor: 'rgb(10, 194, 166)',
          borderWidth: 1,
          borderRadius: 2,
        }],
      },
      options: {
        responsive: false,
        maintainAspectRatio: false,
        plugins: { legend: { display: false }, tooltip: { enabled: false } },
        scales: {
          y: {
            display: true,
            min: 0,
            max: maxVal * 1.1,
            ticks: { font: { size: 10 } },
            grid: { color: 'rgba(128, 128, 128, 0.2)' },
          },
          x: {
            display: true,
            ticks: { font: { size: 10 }, maxRotation: 0 },
            grid: { display: false },
          },
        },
      },
    })

    return () => {
      chartRef.current?.destroy()
    }
  }, [data])

  if (!data) return <span className="text-muted-foreground text-xs">No data</span>

  return <canvas ref={canvasRef} width={300} height={100} />
}
